import {SponsorshipsFactory} from "./sponsorships.factory";
import {SponsorshipsApi} from "./sponsorships.api";
import {BaseRepository} from "../../../infrastructure/repositories/base-repository";
import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../../core/bootstrap/models/site-config";
import {DeviceStore} from "../../../core/app/device.store";
import Sponsorships from '../../../core/app/consts/sponsorships';
import {SponsorshipApiModel} from "../models/sponsorship.api-model";

export class SponsorshipsRepository extends BaseRepository {
  factory: SponsorshipsFactory;

  static injectables = [DomUtils, LoggerUtils, SiteConfig, DeviceStore, SponsorshipsApi, SponsorshipsFactory];

  get sponsorships(): Array<SponsorshipApiModel> {
    const languages: Array<SponsorshipApiModel> = Sponsorships.map((sponsorship: SponsorshipApiModel) => this.factory.createApiObject(sponsorship));

    return languages;
  }
}

